import { create } from 'zustand';

// const useUserToken = create((set) => ({
//     userToken: localStorage.getItem('token') == useUserToken ? useUserToken : null,
//     setUserToken: (token) => set({ userToken: token }),
// }));

const useUserToken = create((set) => ({
    userToken: localStorage.getItem('token'), // Directly fetch the token from localStorage
    setUserToken: (token) => {
        localStorage.setItem('token', token); // Store the token in localStorage
        set({ userToken: token }); // Update the Zustand state
    },
}));

export default useUserToken;

// Usage in other components:

// Import the hook
// import { useUserToken } from './userTokenContext.js';

// Set the user token
// const setUserToken = useUserToken((state) => state.setUserToken);
// setUserToken('your_user_token_here');

// Get the user token
// const userToken = useUserToken((state) => state.userToken);